module.exports = __webpack_public_path__ + "img/info.f965d3a7.png";